// @ts-nocheck

import * as localForage from "localforage";

// server is our url under /api
export const SERVER = window.location.origin + "/api";
// cooking server
export const COOKING_SERVER = "https://cooking.p.neerajkumar.org";
console.log("SERVER", SERVER);
//"http://localhost:19000";

export function is_string(s) {
  return typeof s === "string" || s instanceof String;
}

export function is_dict(d) {
  return typeof d === "object" && d !== null && !Array.isArray(d);
}

export function getCache() {
  return localForage.createInstance({
    driver: localForage.supports(localForage.INDEXEDDB)
      ? localForage.INDEXEDDB
      : localForage.LOCALSTORAGE,
    name: "cookery",
  });
}

export function randomString(length = 8) {
  return Math.random().toString(36).substring(2, length + 2);
}

// generates a categorical color with given index
export function categoricalColor(i) {
  // use 12 highly distinctive pastel colors (all relatively light shaded)
  const colors = [
    "#f3eac2",
    "#c2f3e5",
    "#f3c2e5",

    "#c2e5f3",
    "#e5f3c2",
    "#e5c2c2",

    "#f3e5c2",
    "#c2f3c2",
    "#e5c2f3",

    "#c2c2f3",
    "#c2e5c2",
    "#f3c2c2",
  ];
  return colors[i % colors.length];
}

// converts seconds to dict with values
export function get_hms(secs) {
  let h = 0;
  let m = 0;
  let s = parseInt(secs, 10);
  while (s >= 3600) {
    h += 1;
    s -= 3600;
  }
  while (s >= 60) {
    m += 1;
    s -= 60;
  }
  const ret = {seconds: s};
  ret.minutes = m;
  if (h > 0) {
    ret.hours = h;
    ret.minutes = m;
  }
  return ret;
}

// converts a dict of hms values to a time string
export function time_string(hms, format = ":") {
  let ret = "";
  if (hms.hours) {
    ret += hms.hours;
    if (format === ":") {
      ret += ":";
    } else {
      ret += "hours, ";
    }
  }
  if (format === ":") {
    if (ret.length > 0) {
      ret += ("" + hms.minutes).padStart(2, "0");
    } else {
      ret += hms.minutes;
    }
    ret += ":";
  } else {
    if (hms.minutes > 0) {
      ret += hms.minutes + " minutes,";
    }
  }
  if (format === ":") {
    ret += `${("" + hms.seconds).padStart(2, "0")}`;
  } else {
    if (hms.seconds > 0) {
      ret += hms.seconds + " seconds";
    }
  }
  return ret;
}

// logs state to the server
export function logState(state) {
  fetch(`${SERVER}/log/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(state),
  });
}
